// import React from "react";
// import { Container, Typography, Box, Divider, Paper, Button } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const ClaimInstructionsPage = ({onAgree}) => {
//   const { t } = useTranslation();

//   return (
//     <Box
//       sx={{
//         backgroundColor: "#f5f5f5",
//         minHeight: "100vh",
//         py: 8,
//         px: 2,
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "flex-start",
//       }}
//     >
//       <Container
//         maxWidth="md"
//         sx={{
//           backgroundColor: "white",
//           boxShadow: 3,
//           borderRadius: 2,
//           py: 5,
//           px: 4,
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "80vh",
//         }}
//       >
//         {/* Main Heading */}
//         <Typography
//           variant="h3"
//           align="center"
//           sx={{ fontWeight: "bold", mb: 4, color: "#1976d2" }}
//         >
//           {t("claimInstructions.form.title1")}
//         </Typography>

//         {/* FORM */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #1976d2" }}>
//           {/* <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#0d47a1" }}>
//             {t("claimInstructions.form.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.form.content")}
//           </Typography> */}

//           {Array.from({ length: 20 }).map((_, i) => (
//   <Box key={i}>
//     <Typography variant="h5">{t(`claimInstructions.form.contentHeader${i+1}`)}</Typography>
//     <Typography>{t(`claimInstructions.form.contentSub${i+1}`)}</Typography>
//   </Box>
// ))}

//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* TOKEN */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #388e3c" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#2e7d32" }}>
//             {t("claimInstructions.token.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.token.content")}
//           </Typography>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* SUBMISSION */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #f57c00" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#ef6c00" }}>
//             {t("claimInstructions.submission.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.submission.content")}
//           </Typography>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* SIGNATURE */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #d32f2f" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#c62828" }}>
//             {t("claimInstructions.signature.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.signature.content")}
//           </Typography>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* PRODUCING DOCUMENTS */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #6a1b9a" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#4a148c" }}>
//             {t("claimInstructions.producingDocuments.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.producingDocuments.content")}
//           </Typography>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* NUMBER OF CLAIMS */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #00796b" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#004d40" }}>
//             {t("claimInstructions.numberOfClaims.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.numberOfClaims.content")}
//           </Typography>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* NOTE 1 */}
//         <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: "6px solid #0288d1" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#01579b" }}>
//             {t("claimInstructions.note1.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note1.contentIntro")}
//           </Typography>
//           <Box component="ul" sx={{ pl: 4, fontSize: "1.1rem" }}>
//             <li>{t("claimInstructions.note1.exceptions.1")}</li>
//             <li>{t("claimInstructions.note1.exceptions.2")}</li>
//             <li>{t("claimInstructions.note1.exceptions.3")}</li>
//             <li>{t("claimInstructions.note1.exceptions.4")}</li>
//             <li>{t("claimInstructions.note1.exceptions.5")}</li>
//           </Box>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note1.claimAcceptanceIntro")}
//           </Typography>
//           <Box component="ul" sx={{ pl: 4, fontSize: "1.1rem" }}>
//             <li>{t("claimInstructions.note1.claimAcceptance.1")}</li>
//             <li>{t("claimInstructions.note1.claimAcceptance.2")}</li>
//             <li>{t("claimInstructions.note1.claimAcceptance.3")}</li>
//             <li>{t("claimInstructions.note1.claimAcceptance.4")}</li>
//           </Box>
//         </Paper>

//         <Divider sx={{ my: 3 }} />

//         {/* NOTE 3 */}
//         <Paper elevation={3} sx={{ p: 3, mb: 6, borderLeft: "6px solid #b71c1c" }}>
//           <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#7f0000" }}>
//             {t("claimInstructions.note3.title")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note3.contentIntro")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note3.instructions")}
//           </Typography>
//           <Box component="ul" sx={{ pl: 4, fontSize: "1.1rem" }}>
//             <li>{t("claimInstructions.note3.fileBy.nominee")}</li>
//             <li>{t("claimInstructions.note3.fileBy.legalHeir")}</li>
//           </Box>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note3.attachments")}
//           </Typography>
//           <Typography paragraph sx={{ fontSize: "1.1rem" }}>
//             {t("claimInstructions.note3.multipleHeirs")}
//           </Typography>
//         </Paper>

//         {/* Agree Button */}
//         <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
//           <Button 
//             variant="contained" 
//             color="primary" 
//             size="large"
//             onClick={() => onAgree()}
//           >
//             {t("claimInstructions.agreeButtonText", "Agree")}
//           </Button>

//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default ClaimInstructionsPage;


// import React from "react";
// import { Container, Typography, Box, Divider, Paper, Button } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const ClaimInstructionsPage = ({ onAgree }) => {
//   const { t } = useTranslation();

//   // Define mapping order for clarity and maintainability
//   const sections = [
//     { header: "contentHeader1", subs: ["contentSub1"] },
//     { header: "contentHeader2", subs: ["contentSub2a", "contentSub2b"] },
//     { header: "contentHeader3", subs: ["contentSub3a", "contentSub3b", "contentSub3c"] },
//     { header: "contentHeader4", subs: ["contentSub4a", "contentSub4b"] },
//     { header: "contentHeader5", subs: ["contentSub5"] },
//     { header: "contentHeader6", subs: ["contentSub6"] },
//     { header: "contentHeader7", subs: ["contentSub7a", "contentSub7b", "contentSub7c", "contentSub7d"] },
//     { header: "contentHeader8", subs: ["contentSub8"] },
//     { header: "contentHeader9", subs: ["contentSub9a", "contentSub9b"] },
//     { header: "contentHeader10", subs: ["contentSub10a", "contentSub10b"] },
//     { header: "contentHeader11", subs: ["contentSub11a", "contentSub11b"] },
//     { header: "contentHeader12", subs: ["contentSub12a", "contentSub12b", "contentSub12c"] },
//     { header: "contentHeader13", subs: ["contentSub13a", "contentSub13b", "contentSub13c"] },
//     { header: "contentHeader14", subs: ["contentSub14a", "contentSub14b", "contentSub14c"] },
//     { header: "contentHeader15", subs: ["contentSub15a", "contentSub15b"] },
//     { header: "contentHeader16", subs: ["contentSub16"] },
//     { header: "contentHeader17", subs: ["contentSub17a", "contentSub17b"] },
//     { header: "contentHeader18", subs: ["contentSub18a", "contentSub18b"] },
//     { header: "contentHeader19", subs: ["contentSub19a", "contentSub19b"] },
//     { header: "contentHeader20", subs: ["contentSub20"] },
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundColor: "#f5f5f5",
//         minHeight: "100vh",
//         py: 8,
//         px: 2,
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "flex-start",
//       }}
//     >
//       <Container
//         maxWidth="md"
//         sx={{
//           backgroundColor: "white",
//           boxShadow: 3,
//           borderRadius: 2,
//           py: 5,
//           px: 4,
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "80vh",
//         }}
//       >
//         {/* Main Heading */}
//         <Typography
//           variant="h3"
//           align="center"
//           sx={{ fontWeight: "bold", mb: 4, color: "#1976d2" }}
//         >
//           {t("claimInstructions.form.title1")}
//         </Typography>

//         {/* Sub Heading */}
//         <Typography
//           variant="h5"
//           align="center"
//           sx={{ mb: 5, color: "#0d47a1" }}
//         >
//           {t("claimInstructions.form.title")}
//         </Typography>

//         {/* Auto-mapped sections */}
//         {sections.map((section, index) => (
//           <Paper
//             key={index}
//             elevation={3}
//             sx={{
//               p: 3,
//               mb: 4,
//               borderLeft: `6px solid ${[
//                 "#1976d2",
//                 "#388e3c",
//                 "#f57c00",
//                 "#6a1b9a",
//                 "#00796b",
//                 "#0288d1",
//                 "#f44336",
//               ][index % 7]}`,
//             }}
//           >
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ fontWeight: "bold", color: "#0d47a1" }}
//             >
//               {t(`claimInstructions.form.${section.header}`)}
//             </Typography>

//             {section.subs.map((sub, subIndex) => (
//               <Typography
//                 key={subIndex}
//                 paragraph
//                 sx={{ fontSize: "1.1rem", whiteSpace: "pre-line" }}
//               >
//                 {t(`claimInstructions.form.${sub}`)}
//               </Typography>
//             ))}
//           </Paper>
//         ))}

//         {/* Agree Button */}
//         <Divider sx={{ my: 3 }} />
//         <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
//           <Button
//             variant="contained"
//             color="primary"
//             size="large"
//             onClick={() => onAgree()}
//           >
//             {t("claimInstructions.agreeButtonText", "Agree")}
//           </Button>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default ClaimInstructionsPage;

import React from "react";
import { Container, Typography, Box, Divider, Paper, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const ClaimInstructionsPage = ({ onAgree }) => {
  const { t } = useTranslation();

  // All instructions except last download
  const sections = [
    { header: "contentHeader1", subs: ["contentSub1"] },
    { header: "contentHeader2", subs: ["contentSub2a", "contentSub2b"] },
    { header: "contentHeader3", subs: ["contentSub3a", "contentSub3b", "contentSub3c"] },
    { header: "contentHeader4", subs: ["contentSub4a", "contentSub4b"] },
    { header: "contentHeader5", subs: ["contentSub5"] },
    { header: "contentHeader6", subs: ["contentSub6"] },
    { header: "contentHeader7", subs: ["contentSub7a", "contentSub7b", "contentSub7c", "contentSub7d"] },
    { header: "contentHeader8", subs: ["contentSub8"] },
    { header: "contentHeader9", subs: ["contentSub9a", "contentSub9b"] },
    { header: "contentHeader10", subs: ["contentSub10a", "contentSub10b"] },
    { header: "contentHeader11", subs: ["contentSub11a", "contentSub11b"] },
    { header: "contentHeader12", subs: ["contentSub12a", "contentSub12b", "contentSub12c"] },
    { header: "contentHeader13", subs: ["contentSub13a", "contentSub13b", "contentSub13c"] },
    { header: "contentHeader14", subs: ["contentSub14a", "contentSub14b", "contentSub14c"] },
    { header: "contentHeader15", subs: ["contentSub15a", "contentSub15b"] },
    { header: "contentHeader16", subs: ["contentSub16"] },
    { header: "contentHeader17", subs: ["contentSub17a", "contentSub17b"] },
    { header: "contentHeader18", subs: ["contentSub18a", "contentSub18b"] },
    { header: "contentHeader19", subs: ["contentSub19a", "contentSub19b"] }
    // Download handled separately
  ];

  // S3 URL and label from i18n
  const downloadHeader = t("claimInstructions.form.contentHeader20");
  const downloadUrl = t("claimInstructions.form.contentSub20");
  const downloadButtonLabel = t("claimInstructions.form.downloadButtonText", "Download");

const handleDownloadClick = () => {
  // Make sure downloadUrl is a string: "https://splocamedia.s3.amazonaws.com/fe/pVLQpQDTinternship.jpg"
  window.open(downloadUrl, "_blank", "noopener,noreferrer");
};



  return (
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        py: 8,
        px: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          backgroundColor: "white",
          boxShadow: 3,
          borderRadius: 2,
          py: 5,
          px: 4,
          display: "flex",
          flexDirection: "column",
          minHeight: "80vh",
        }}
      >
        {/* Main Heading */}
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: "bold", mb: 4, color: "#1976d2" }}
        >
          {t("claimInstructions.form.title1")}
        </Typography>

        {/* Sub Heading */}
        <Typography
          variant="h5"
          align="center"
          sx={{ mb: 5, color: "#0d47a1" }}
        >
          {t("claimInstructions.form.title")}
        </Typography>

        {/* Auto-mapped instructions */}
        {sections.map((section, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              p: 3,
              mb: 4,
              borderLeft: `6px solid ${[
                "#1976d2",
                "#388e3c",
                "#f57c00",
                "#6a1b9a",
                "#00796b",
                "#0288d1",
                "#f44336",
              ][index % 7]}`,
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#0d47a1" }}
            >
              {t(`claimInstructions.form.${section.header}`)}
            </Typography>
            {section.subs.map((sub, subIndex) => (
              <Typography
                key={subIndex}
                paragraph
                sx={{ fontSize: "1.1rem", whiteSpace: "pre-line" }}
              >
                {t(`claimInstructions.form.${sub}`)}
              </Typography>
            ))}
          </Paper>
        ))}

        {/* Dedicated Download Section */}
        <Paper
          elevation={3}
          sx={{
            p: 3,
            mb: 4,
            borderLeft: "6px solid #0d47a1",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#0d47a1" }}
          >
            {downloadHeader}
          </Typography>
          <Button
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={handleDownloadClick}
          >
            {downloadButtonLabel}
          </Button>
        </Paper>

        {/* Agree Button */}
        <Divider sx={{ my: 3 }} />
        <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={onAgree}
          >
            {t("claimInstructions.form.agreeButtonText", "Agree")}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ClaimInstructionsPage;
